import { Component, OnInit } from '@angular/core';
import { KuiModalRefComponent } from 'app/key-ui/modal/modal-ref.component';
import { IKuiModalAction } from 'app/key-ui';
import { TranslateService } from '@ngx-translate/core';


export interface ConfirmModalOptions {
    message: string;
}

@Component({
    templateUrl: 'confirm.component.html',
    standalone: false
})
export class ConfirmModalComponent extends KuiModalRefComponent<ConfirmModalOptions> implements OnInit {

    modalActions: IKuiModalAction[];

    constructor(
        private i18n: TranslateService
    ) {
        super();
    }

    ngOnInit() {

        this.modalActions = [{
            text: this.i18n.instant('DIALOG.CANCEL'),
            style: 'secondary',
            keypress: 27,
            action: () => {
                this.actions.close(false);
            },
        }, {
            text: this.i18n.instant('DIALOG.OK'),
            style: 'primary',
            action: () => {
                this.actions.close(true);
            },
        }];

    }

    detachModal() {
        this.actions.close(false);
    }



}
